module.exports = __webpack_public_path__ + "img/gossip-step-button.57bd39f6.svg";